import React from "react";
import { useTranslation } from "react-i18next";

import { InstagramData } from "../../../../../utils/getInstagramStatus";

export interface IInstagramIntegrationStatusDisplayProps {
  instagramData: InstagramData;
}

export const InstagramIntegrationStatusDisplay: React.FunctionComponent<
  IInstagramIntegrationStatusDisplayProps
> = (props) => {
  const { instagramData } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.externalIntegrations.${key}`);

  if (instagramData.status === "healthy") {
    return (
      <div className="btn btn-blue btn-blue--decorative">
        <i className="icons icon-instagram"></i>@{instagramData.username}
        &nbsp;
        {t("instagram_integrated")}
      </div>
    );
  }

  if (instagramData.status === "insufficient_permissions") {
    return (
      <div className="btn btn-red btn-red--decorative">
        <i className="icons icon-instagram"></i>@{instagramData.username}
        &nbsp;
        {t("instagram_insufficient_permissions")}
      </div>
    );
  }

  if (instagramData.status === "invalid") {
    return (
      <div className="btn btn-red btn-red--decorative">
        <i className="icons icon-instagram"></i>@{instagramData.username}
        &nbsp;
        {t("instagram_invalid")}
      </div>
    );
  }

  return null;
};
